import {BaseApi} from "./BaseApi";

export class UserApi extends BaseApi {

  // Returns the Auth0 userinfo (name, email, given_name, family_name, ...) of the
  // currently logged-in user. Requires a valid session (access token).
  public getMe(): Promise<any> {
    return this.requestGet('/user/me');
  }

  // Builds the order-contact payload (name + email) for the logged-in user, used
  // to attribute an order when it is approved from inside a cockpit session.
  public getMeAsOrderContact(): Promise<{name?: string, email?: string} | undefined> {
    return this.getMe().then((me: any) => {
      if (!me) {
        return undefined;
      }
      const fullName = me.name || [me.given_name, me.family_name].filter(Boolean).join(" ");
      const name = (fullName || "").trim();
      return {
        name: name || undefined,
        email: me.email || undefined,
      };
    });
  }
}

export default new UserApi();
